// Top bar: the wordmark (plain type, no logo is approved) and, from 1024 px, the top navigation. Workspace
// switcher, command field, processing mode, notifications and account arrive with sign-in (L4-03); nothing
// stands here as a stand-in for them.

import { Link } from "react-aria-components";
import { useT } from "../../lib/i18n";
import { NavEntry } from "./NavEntry";
import { navItems } from "./navigation";

export function TopBar() {
  const t = useT();
  return (
    <header className="sf-topbar">
      <Link className="sf-wordmark" href="/" aria-label={t("shell.home")}>
        {t("brand.name")}
      </Link>
      <nav className="sf-topnav" aria-label={t("shell.nav")}>
        {navItems
          .filter((item) => item.desk)
          .map((item) => (
            <NavEntry key={item.id} item={item} variant="top" />
          ))}
      </nav>
    </header>
  );
}
